import { IndexedArray } from '@common/types';

export const isSelectorEmpty = <T>(selector?: Array<T> | IndexedArray<T> | {} | [] | null, checkLength: boolean = false) => {
  const isEmpty = !selector || (!Object.keys(selector).length && !Array.isArray(selector)) || (Array.isArray(selector) && !selector.length);
  return checkLength ? !(selector as Array<T>)?.length || isEmpty : isEmpty;
};
